import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  {
    product: 'Sponsorship La Dosis Positiva',
    detail: 'Lifestyle & Wellness Sponsor',
    investment: '$80',
  },
  {
    product: 'Plan Mensual UGC',
    detail: '1 pieza de video semanal (4 total)',
    investment: '$100',
  },
  {
    product: 'Plan Rotativa Network',
    detail: 'Frecuencia horaria 24/7 + Bonificación',
    investment: '$180',
  },
];

const InvestmentSummary = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Resumen
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Resumen de Inversión Final
        </Box>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 720, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Producto</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Detalle</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                Inversión Mensual
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
                <TableCell align="right">{row.investment}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.light }}>
              <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                TOTAL MENSUAL
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>
                $360
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          <strong>Bonificación (Plan Rotativa):</strong> 4 historias en TNO Network + banner en la página del programa (medida: 2001×701 px). Todo con enlace dofollow.
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          <strong>Forma de pago:</strong> 50% intercambio por productos de Lácteos Barinas ($180 en producto) + 50% en efectivo ($180).
        </Typography>
      </Box>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
